import { AUTH_TOKEN } from "../../../constants";
import {
  PARTNER_LOGIN,
  PARTNER_USER_PROFILE,
  VERIFY_PARTNER,
} from "../../../gql/auth";
import { ROUTE_DASHBOARD } from "../../../constants/route";
import { ApolloClientPartnerService } from "../../../services/ApolloClientPartnerService";
import { setErrorMsg, setUser } from "./reducer";
import { deleteItem, setItem } from "../../../helpers/cookies";
import { errorHandling } from "../../../helpers/errorHandling";

/**
 * Login action
 * @param {*} param0
 * @param {*} dispatch
 * @param {*} history
 */
export const userLoginAction = async ({ input }, dispatch, history) => {
  try {
    const { data } = await ApolloClientPartnerService.mutate({
      mutation: PARTNER_LOGIN,
      operationName: "PARTNER_LOGIN",
      variables: { input },
      fetchPolicy: "network-only",
    });
    const response = data?.loginPartnerAuth || {};
    const { token, userData } = response || {};
    if (token) {
      dispatch(setUser(userData || {}));
      setItem(AUTH_TOKEN, token);
      history(ROUTE_DASHBOARD);
    } else {
      dispatch(setErrorMsg("Something went wrong..."));
    }
    return response;
  } catch (err) {
    dispatch(setErrorMsg(err?.message || "Something went wrong..."));
    errorHandling(err);
  }
  // unset error msg after 5s
  setTimeout(() => {
    dispatch(setErrorMsg(null));
  }, 3500);
};

/**
 * Login action
 * @param {*} param0
 * @param {*} dispatch
 * @param {*} history
 */

export const userProfileAction = async (dispatch) => {
  try {
    const { data } = await ApolloClientPartnerService.query({
      query: PARTNER_USER_PROFILE,
      operationName: "PARTNER_USER_PROFILE",
      fetchPolicy: "network-only",
    });
    const user = data?.partnerUserProfile || {};
    if (user) {
      dispatch(setUser(user || {}));
    } else {
      dispatch(setUser({}));
      dispatch(setErrorMsg("Something went wrong..."));
    }
    return user;
  } catch (err) {
    dispatch(setErrorMsg(err?.message || "Something went wrong..."));
    errorHandling(err);
  }
};

export const logoutUser = () => {
  return async (dispatch) => {
    try {
      deleteItem(AUTH_TOKEN); // Removes the token from storage
      dispatch(setUser({})); // Resets user state
      dispatch(setErrorMsg(null)); // Clear error messages if any
    } catch (err) {
      dispatch(setErrorMsg(err?.message || "Something went wrong..."));
    }
  };
};

export const verifyUser = ({ input }) => {
  return async (dispatch) => {
    try {
      const { data } = await ApolloClientPartnerService.query({
        query: VERIFY_PARTNER,
        operationName: "VERIFY_PARTNER",
        variables: { input },
        fetchPolicy: "network-only",
      });
      const user = data?.verifyPartnerUser || {};
      return user;
    } catch (err) {
      dispatch(setErrorMsg(err?.message || "Something went wrong..."));
    }
  };
};
